<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
  >
    <b-form-group
      :label="label" 
      label-for="input"
      :label-cols="labelCols"
    >
      <b-row class="date-picker-row">
        <filter-date-picker
          v-on:onChange="$emit('onChange', $event)"
          placeholder="с"
          :cols="6"
          v-model="value[0]"
          :notAfter="value[1]"
          class="small-padding"
        ></filter-date-picker>
        <filter-date-picker
          v-on:onChange="$emit('onChange', $event)"
          placeholder="по"
          :cols="6"
          v-model="value[1]"
          :notBefore="value[0]"
          class="small-padding"
        ></filter-date-picker>
      </b-row>
    </b-form-group>
  </b-col>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
  name: 'filter-date-between',
  props: ['value', 'cols', 'labelCols', 'label'],
  data() {
    return {
      lang: 'ru',
    };
  },
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
  created() {
      this.lang = (localStorage.lang || 'ru').toLowerCase();
      EventBus.$on('lang-changed', (lang) => {
        this.lang = lang;
      });
  }
};
</script>